import React, { useRef, useEffect } from "react";
import "./Popup.css";

const Popup = ({ onClose, title, children, txtSubHeading }) => {
  const popupRef = useRef();

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [onClose]);

  return (
    <div className="popup">
      <div className="popup-content" ref={popupRef}>
        <div className="modal-header" style={{ borderBottom: "0px none" }}>
          <h3 className="fc3">{title && title}</h3>
        </div>
        {txtSubHeading && (
          <div className="fs14 fc6 fw4 lh22 ls1">{txtSubHeading}</div>
        )}

        <div className="modal-body pr">{children}</div>
      </div>
    </div>
  );
};

export default Popup;
